export const ga4FormatId = string => {
  if (!string) return '';
  return string
    .toLowerCase()
    .split(' ')
    .join('-');
};

const formatPrice = num => Math.round((num + Number.EPSILON) * 100) / 100;

const formatItem = (item, index, list) => {
  let obj = {
    // item_id: item.id,
    item_id: typeof item.id === 'string' ? item.id : String(item.id),
    item_name: item.name,
    currency: 'EUR',
    price: formatPrice(item.price), // TODO: google lo legge in milioni, capire se ok
    quantity: item.quantity || 1,
    item_brand: item.brand,
    item_category: item.type,
    item_category2: item.categoryName,
    item_category3: item.subcategoryName,

    discount: formatPrice((item.listPrice || item.price) - item.price), // TODO: non appare in analytics

    // location_id: "L_12345", // TODO: cosa sarebbe ?
    // affiliation: "Google Merchandise Store", // TODO: cosa sarebbe ?
  };

  if (list) {
    obj = {
      ...obj,
      index,
      item_list_id: ga4FormatId(list.id),
      item_list_name: list.name,
    };
  }

  return obj;
};

export function ga4ViewItemList(products = [], listInfo) {
  try {
    if (!!window.gtag && !!listInfo) {
      window.gtag('event', 'view_item_list', {
        item_list_id: ga4FormatId(listInfo.id),
        item_list_name: listInfo.name,
        items: products.map((product, index) =>
          formatItem(product, index, listInfo)
        ),
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4SelectItem(product, listInfo) {
  try {
    if (!!window.gtag && !!product && !!listInfo) {
      window.gtag('event', 'select_item', {
        item_list_id: ga4FormatId(listInfo.id),
        item_list_name: listInfo.name,
        items: [formatItem(product, 0, listInfo)],
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4ViewItem(product) {
  try {
    if (!!window.gtag && !!product) {
      window.gtag('event', 'view_item', {
        currency: 'EUR',
        value: product.price,
        items: [formatItem(product, 0)],
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4ViewPromotion(banner) {
  try {
    if (!!window.gtag && !!banner) {
      window.gtag('event', 'view_promotion', {
        creative_name: banner.name,
        creative_slot: banner.homePosition,
        promotion_id: banner.id,
        promotion_name: banner.seoName,
        // location_id: "L_12345", // TODO: cosa è?

        // non possiamo usarlo nella home, diventerebbe troppo pesante il caricamento
        // items: products.map((product, index) => formatItem(product, index))
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4SelectPromotion(banner) {
  try {
    if (!!window.gtag && !!banner) {
      window.gtag('event', 'select_promotion', {
        creative_name: banner.name,
        creative_slot: banner.homePosition,
        promotion_id: banner.id,
        promotion_name: banner.seoName,
        // location_id: "L_12345", // TODO: cosa è?

        // non possiamo usarlo nella home, diventerebbe troppo pesante il caricamento
        // items: products.map((product, index) => formatItem(product, index)),
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4AddToCart(product, listInfo) {
  try {
    if (!!window.gtag && !!product) {
      window.gtag('event', 'add_to_cart', {
        currency: 'EUR',
        value: product.price, // FIXME: capire se riguarda il prodotto o il carrello
        items: [formatItem(product, 0, listInfo)],
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4RemoveFromCart(product) {
  try {
    if (!!window.gtag && !!product) {
      window.gtag('event', 'remove_from_cart', {
        currency: 'EUR',
        value: product.price, // FIXME: capire se riguarda il prodotto o il carrello
        items: [formatItem(product, 0)],
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4ViewCart(products = [], value = 0) {
  try {
    if (!!window.gtag) {
      window.gtag('event', 'view_cart', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4BeginCheckout(products = [], value = 0) {
  try {
    if (window.gtag) {
      window.gtag('event', 'begin_checkout', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),

        // coupon: "SUMMER_FUN", // TODO: gestire coupon
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4AddShippingInfo(products = [], value = 0, shippingInfo) {
  try {
    if (!!window.gtag && !!shippingInfo) {
      window.gtag('event', 'add_shipping_info', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),
        shipping_type: shippingInfo.type,
        shipping_cost: shippingInfo.cost,
        shipping_with_pudo: shippingInfo.withPudo,

        // coupon: "SUMMER_FUN", // TODO: gestire coupon
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4AddPaymentInfo(products = [], value = 0, paymentInfo) {
  try {
    if (!!window.gtag && !!paymentInfo) {
      window.gtag('event', 'add_payment_info', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),
        payment_type: paymentInfo.type,
        payment_cost: paymentInfo.cost,

        // coupon: "SUMMER_FUN", // TODO: gestire coupon
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4Purchase(order) {
  try {
    if (!!window.gtag && !!order) {
      window.gtag('event', 'purchase', {
        transaction_id: order.id,
        currency: 'EUR',
        value: order.revenue,
        shipping: order.shipping,
        tax: order.tax,
        coupon: order.coupon,
        items: order.items.map((product, index) => formatItem(product, index)),

        // affiliation: "Google Merchandise Store", // TODO: non lo abbiamo
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function ga4Search(search_term = '') {
  try {
    if (!!window.gtag) {
      window.gtag('event', 'search', {
        search_term,
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}
